import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { DataSharingService } from '../../services/data-sharing.service';
import { DownloadService } from '../../services/download.service';
import { publicMethods } from '../../globals';
import { DashboardBulkSelection, selectionCount, selectionIds, selectionParams } from '../../types/dashboard-bulk-selection';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css'],
  standalone: false,
})
export class DownloadsComponent implements OnInit, OnChanges {
  private readonly destroyed = new Subject<void>();
  selection: DashboardBulkSelection;
  userIndividualDownloadLimit: number = Infinity;
  @Input('selection') set dashboardSelection(value: DashboardBulkSelection) {
    this.selection = value;
    if (value) {
      this.companyIds = selectionIds(value); this.searchParams = selectionParams(value);
      this.selectedCompanyCount = selectionCount(value);
    }
  }
  get canDownload(): boolean {
    return Number.isSafeInteger(this.selectedCompanyCount) && this.selectedCompanyCount > 0 &&
      this.selectedCompanyCount <= this.userRemainingDownloads && this.selectedCompanyCount <= this.userIndividualDownloadLimit;
  }
  companyIds: Array<any> = [];
  searchParams: HttpParams = null;
  downloadUrl: string;
  downloadRequestId: string;

  userDownloadUsage: number;
  userDownloadLimit: number;
  userRemainingDownloads: number;
  selectedCompanyCount: number = 0;
  userDownloadFormat = [];
  // TODO: some of this is already known from companyIds/searchParams subscriptions and could be merged
  @Input() inputParams: Record<string, any> = {}; // {'totalCompaniesSelected': totalCompaniesSelected, 'totalCompanyCount': companyCount.count, 'hasSelectedTotalNumberMatchingFilter': hasSelectedTotalNumberMatchingFilter}

  @Output() downloadDataFetched = new EventEmitter<boolean>();

  constructor(
    private downloadService: DownloadService,
    private data: DataSharingService,
    public pubMethods: publicMethods
  ) {}

  isLoading = this.downloadService.isLoading;

  ngOnInit() {
    $('#downloadModal').on('hide.bs.modal.bulkDownload', () => {
      this.downloadUrl = null;
      this.downloadRequestId = null;
    });
    this.data.currentSelectedCompanyIds.pipe(takeUntil(this.destroyed)).subscribe(
      companyIds => { if (!this.selection) this.companyIds = companyIds; }
    );
    this.data.currentSelectedSearchParams.pipe(takeUntil(this.destroyed)).subscribe(
      searchParams => { if (!this.selection) this.searchParams = searchParams; }
    );

    this.downloadService.getDownloadUsage().pipe(takeUntil(this.destroyed)).subscribe(data => {
      if (this.pubMethods.hasData(data)) {
        this.userDownloadUsage = data.downloads_this_period || 0;
        this.userDownloadLimit = data.total_download_limit;
        this.userIndividualDownloadLimit = data.individual_download_limit ?? Infinity;
        this.userRemainingDownloads =
          this.userDownloadLimit - this.userDownloadUsage;
        this.parseDownloadFormat(data.user_download_format);
      }
      this.downloadDataFetched.emit(true);
    });
  }

  parseDownloadFormat(rawUserDownloadFormat): void {
    this.userDownloadFormat = rawUserDownloadFormat
      ?.map(el => {
        try {
          return JSON.parse(el);
        } catch (err) {
          return el;
        }
      })
      .filter(Boolean);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.selection || !changes.inputParams) return;
    if (changes.inputParams.currentValue.hasSelectedTotalNumberMatchingFilter) {
      this.selectedCompanyCount =
        changes.inputParams.currentValue.totalCompanyCount;
    } else {
      this.selectedCompanyCount =
        changes.inputParams.currentValue.totalCompaniesSelected;
    }
  }

  processDownloadLink(output): void {
    if (output.download_url) {
      this.downloadUrl = output.download_url;
      window.open(this.downloadUrl);
    } else if (output.download_request_id) {
      this.downloadRequestId = output.download_request_id;
    }
  }

  generateCSVDownloadUrl(): void {
    if (!this.canDownload) return;
    this.downloadUrl = null;
    this.downloadRequestId = null;
    this.downloadService
      .downloadCompanies(this.companyIds, this.searchParams)
      .subscribe(output => this.processDownloadLink(output));
  }

  ngOnDestroy(): void {
    this.destroyed.next(); this.destroyed.complete();
    $('#downloadModal').off('.bulkDownload');
  }
}
